<template>
  <div class="my-filter-excel">
    <div class="my-fe-top">
      <!-- <ul class="my-fe-menu-group">
        <li class="my-fe-menu-link">
          <span>升序</span>
        </li>
        <li class="my-fe-menu-link">
          <span>倒序</span>
        </li>
      </ul> -->
      <ul class="my-fe-menu-group">
        <!-- <li class="my-fe-menu-link" @click="load()">
          <i id="iconContainer--funnel" class="vxe-icon--refresh"></i>
          <span>数据不对？点击此处刷新</span>
        </li> -->
        <li class="my-fe-menu-link" @click="resetFilterEvent">
          <span>清除筛选</span>
        </li>
        <li class="my-fe-menu-link">
          <i id="iconContainer--funnel" class="vxe-icon--funnel"></i>
          <span>筛选条件</span>
          <span :class="[option.data.fMenu === '' ? '' : 'high-filter-span']">{{ option.data.fMenu }}</span>
          <i id="iconContainer--right" class="el-icon-caret-right"></i>
          <div class="my-fe-menu-child-list">
            <div class="filter--ul" v-for="(cList, gIndex) in caseGroups" :key="gIndex">
              <div
                class="filter--li"
                :class="[option.data.fMenu === cItem.lable ? 'is-active' : '']"
                v-for="(cItem, cIndex) in cList"
                :key="cIndex"
                @click="childMenuClickEvent(cItem)"
              >
                <span>{{ cItem.label }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="my-fe-search">
      <div class="my-fe-search-top">
        <el-input size="mini" v-model="option.data.sVal" placeholder="搜索">
          <i slot="suffix" class="el-icon-search"></i>
        </el-input>
      </div>
      <ul class="my-fe-search-list">
        <li class="my-fe-search-item" @click="sAllEvent">
          <i id="iconContainer--checkbox" class="iconfont fjyk-pick-all-checkbox"></i>
          <span>全选</span>
        </li>
        <li class="my-fe-search-item" v-for="(val, sIndex) in searchList" :key="sIndex" @click="sItemEvent(val.value)">
          <i
            id="iconContainer--checkbox"
            :class="[
              option.data.vals.indexOf(val.value) === -1
                ? 'iconfont fjyk-no-pick-checkbox'
                : 'iconfont fjyk-pick-checkbox'
            ]"
          ></i>
          <!-- val: 张三; countObj:{ 张三:4 } -->
          <span>{{ `${val.label.replace(/[(!&!)|(!#!)]/g, '')}（${countObj[val.value]}）` }}</span>
          <button class="only-filter-btn" @click.stop="onlyFilterEvent(val.value)">仅筛选</button>
        </li>
      </ul>
    </div>
    <div class="my-fe-footer">
      <el-button type="primary" size="mini" @click="confirmFilterEvent">确认</el-button>
      <el-button size="mini" @click="resetFilterEvent">重置</el-button>
    </div>
  </div>
</template>

<script>
// sVal：输入框值
import XEUtils from 'xe-utils'

export default {
  name: 'FilterExtendCompany',
  props: {
    params: Object
  },
  data() {
    return {
      column: null,
      option: null,
      // 数据是否加载完成
      isFirstLoad: false,
      // 筛选条件
      colValList: [],
      // 筛选条件对应的数量
      countObj: {},
      caseGroups: [
        [
          { value: 'includes', label: '包含' },
          // { value: 'unincludes', label: '不包含' }
        ]
        // [
        //   { value: 'equal', label: '等于' },
        //   { value: 'ne', label: '不等于' }
        // ],
        // [
        //   { value: 'greater', label: '大于' },
        //   { value: 'ge', label: '大于或等于' },
        //   { value: 'less', label: '小于' },
        //   { value: 'le', label: '小于或等于' }
        // ]
      ]
      // 选中的筛选条件
      // option.data.fMenu: ''
    }
  },
  computed: {
    searchList() {
      let { option, colValList } = this
      let companyList = []
      colValList.forEach(col => {
        if (String(col).includes('!#!')) {
          String(col)
            .split('!#!')
            .forEach(item => {
              companyList.push(item)
            })
        } else {
          companyList.push(col)
        }
      })
      colValList = Array.from(new Set(companyList))
      // 将显示与实际值分离，达到格式化label的效果
      colValList = colValList.map(val => {
        val = {
          label: val,
          value: val
        }
        return val
      })
      // 选了筛选条件 [包含 | 不包含]
      if (option?.data.fMenu && option?.data.sVal) {
        if (option.data.fMenu === '包含') {
          // val.value: 搜索框输入值
          // option.data.sVal: 勾选的筛选项
          return colValList.filter(val =>
            String(val.value).toLowerCase().includes(String(option.data.sVal).toLowerCase())
          )
        } else {
          return colValList.filter(
            val => !String(val.value).toLowerCase().includes(String(option.data.sVal).toLowerCase())
          )
        }
      }
      // 没有选筛选条件的情况
      return option?.data.sVal
        ? colValList.filter(val => String(val.value).toLowerCase().indexOf(String(option.data.sVal).toLowerCase()) > -1)
        : colValList
    }
  },
  watch: {
    searchList: {
      handler() {
        // 非首次加载的情况下，筛选条件列表发生了变化，才进行筛选条件的清空
        if (!this.isFirstLoad) {
          this.option.data.vals = []
        }
      },
      deep: true
    }
  },
  created() {
    console.log(2)
    this.load()
  },
  methods: {
    // 将日期按降序排序
    dateDesc(a, b) {
      if (a < b) {
        return 1
      }
      if (a > b) {
        return -1
      }
      return 0
    },
    /**
     * 格式化日期
     * @param {Array} fullData 表格全部数据
     * @param {String} colName 列名
     */
    // formatDateByCol(fullData, colName) {
    //   return fullData.map(row => {
    //     if (typeof row[colName] === 'string' && row[colName].includes('1900-01-01')) {
    //       row[colName] = ''
    //     }
    //     return row
    //   })
    // },
    load() {
      const { $table, column } = this.params
      let filterData = []

      // 修改逻辑 liufu 220802
      const filterOptions = $table.getCheckedFilters().filter(item => item.property !== column.property)
      // 如果只筛选了本列数据则获取全量数据
      if (filterOptions.length < 1) {
        filterData = $table.getTableData().fullData
      } else {
        // 否则过滤出除去本列的过滤外,满足其他列筛选的所有数据
        filterData = $table.getTableData().fullData.filter(row => {
          let flag = true
          for (let filter of filterOptions) {
            if (!filter.datas[0].vals.includes(String(row[filter.property]))) {
              flag = false
            }
          }
          return flag
        })
      }

      // 标记当前为首次加载的状态，不清空筛选条件
      this.isFirstLoad = true
      const option = column.filters[0]
      // 对数据中的1900进行格式化
      // const data = this.formatDateByCol(visibleData, column.property)
      // 筛选条件 ['a', 'b', 'c']
      let colValList = Object.keys(XEUtils.groupBy(filterData, column.property))
      let companyList = []
      colValList.forEach(col => {
        if (String(col).includes('!#!')) {
          String(col)
            .split('!#!')
            .forEach(item => {
              companyList.push(item)
            })
        } else {
          companyList.push(col)
        }
      })
      colValList = Array.from(new Set(companyList))
      // 筛选条件值对应的数量 {a:2, b:4}
      // const countObj = XEUtils.countBy(filterData, column.property)
      const countObj = {}
      colValList.forEach(col => {
        filterData.forEach(item => {
          if (String(item[column.property]).includes(col)) {
            countObj[col] ? (countObj[col] += 1) : (countObj[col] = 1)
          }
        })
      })

      // 默认勾选显示数据 liufu 220802
      const visibleList = []
      for (let row of $table.getTableData().visibleData) {
        if (String(row[column.property]).includes('!#!')) {
          for (let item of String(row[column.property]).split('!#!')) {
            !visibleList.includes(item) && visibleList.push(item)
          }
        } else {
          !visibleList.includes(String(row[column.property])) && visibleList.push(String(row[column.property]))
        }
      }
      option.data.vals = visibleList
      // 每次重新打开都清空搜索框的值，避免缓存引起的显示打钩状态不对
      option.data.sVal = ''
      this.column = column
      this.option = option
      this.colValList = colValList
      this.countObj = countObj

      this.$nextTick(() => {
        // 标记当前不为首次加载的状态
        this.isFirstLoad = false
      })
    },
    // 全选
    sAllEvent() {
      const { data } = this.option
      if (data.vals.length > 0) {
        // 1.取消全选：当有一个筛选项勾选时，再次点击全选会进行反选
        data.vals = []
      } else {
        // 2.进行全选
        if (this.option.data.sVal) {
          // 2.1 搜索框有值
          if (this.option.data.fMenu === '' || this.option.data.fMenu === '包含') {
            // 高级筛选条件为【包含】
            // 注意！不能让data.vals直接等于filter返回的函数，会让vue监听不到勾选的状态！需要加上扩展符让vue对该数组进行监听！
            data.vals = [
              ...this.colValList.filter(val =>
                String(val).toLowerCase().includes(String(this.option.data.sVal).toLowerCase())
              )
            ]
          } else {
            // 高级筛选条件为【不包含】
            data.vals = [
              ...this.colValList.filter(
                val => !String(val).toLowerCase().includes(String(this.option.data.sVal).toLowerCase())
              )
            ]
          }
        } else {
          // 2.2 搜索框无值
          data.vals = [...this.colValList]
        }
      }
    },
    // 仅筛选某个项
    onlyFilterEvent(val) {
      // 重置筛选状态
      const { data } = this.option
      data.vals = []

      // 自动勾选当前值
      this.sItemEvent(val)
      // 自动调用筛选事件
      this.confirmFilterEvent()
    },
    // 筛选项点击事件
    sItemEvent(val) {
      const { data } = this.option
      // data.vals：筛选项列表
      const vIndex = data.vals.indexOf(val)

      if (vIndex === -1) {
        // 勾选
        // 注意！此处必须使用 push 和 splice！因为vue对该方法进行了重构，让使用了该方法的数组能被vue监听
        data.vals.push(val)
      } else {
        // 取消勾选
        data.vals.splice(vIndex, 1)
      }
    },
    confirmFilterEvent(evnt) {
      const { params, option } = this
      const { data } = option
      const { $panel, column, $table } = params
      const filterData = $table.getTableData().fullData
      data.f1 = ''
      data.f2 = ''
      let vals = []
      for (let val of option.data.vals) {
        Object.keys(XEUtils.groupBy(filterData, column.property)).forEach(item => {
          if (String(item).includes(val)) {
            vals.push(item)
          }
        })
      }
      option.data.vals = vals
      $panel.changeOption(evnt, true, option)
      $panel.confirmFilter()
    },
    resetFilterEvent() {
      const { $panel } = this.params
      const { option } = this

      option.data.fMenu = ''
      $panel.resetFilter()
    },
    // 筛选条件确认
    childMenuClickEvent(cItem) {
      const { option } = this
      if (option.data.fMenu === cItem.label) {
        // 清空筛选条件
        option.data.fMenu = ''
      } else {
        // 赋值高级筛选条件
        option.data.fMenu = cItem.label
      }
      // this.$XModal.alert({ content: cItem.label })
    }
  }
}
</script>

<style lang="less" scoped>
.my-filter-excel {
  user-select: none;
  max-width: 250px;
}
.my-filter-excel .my-fe-top .my-fe-menu-group {
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}
.my-filter-excel .my-fe-top .my-fe-menu-group:after {
  content: '';
  position: absolute;
  width: 190px;
  right: 0;
  bottom: 0;
  // border-bottom: 1px solid #e2e4e7;
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link {
  position: relative;
  padding: 4px 20px 4px 30px;
  margin: 5px 0;
  cursor: pointer;
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link:hover {
  background-color: #c5c5c5;
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link-left-icon {
  position: absolute;
  left: 10px;
  top: 6px;
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link-right-icon {
  position: absolute;
  right: 10px;
  top: 6px;
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link:hover .my-fe-menu-child-list {
  display: block;
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link .my-fe-menu-child-list {
  display: none;
  position: absolute;
  top: 0;
  right: -120px;
  width: 120px;
  background-color: #fff;
  border: 1px solid #dadce0;
  box-shadow: 3px 3px 4px -2px rgba(0, 0, 0, 0.6);
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link .my-fe-child-menu-group-list {
  position: relative;
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link .my-fe-child-menu-group-list:after {
  content: '';
  position: absolute;
  width: 90px;
  right: 0;
  bottom: 0;
  border-bottom: 1px solid #e2e4e7;
}
.my-filter-excel .my-fe-top .my-fe-menu-group .my-fe-menu-link .my-fe-child-menu-group-list > .my-fe-child-menu-item {
  position: relative;
  padding: 4px 20px 4px 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.my-filter-excel
  .my-fe-top
  .my-fe-menu-group
  .my-fe-menu-link
  .my-fe-child-menu-group-list
  > .my-fe-child-menu-item:hover {
  background-color: #c5c5c5;
}
.my-filter-excel .my-fe-search {
  padding: 0 10px 0 30px;
}
.my-filter-excel .my-fe-search .my-fe-search-top {
  position: relative;
  padding: 5px 0;
}
.my-filter-excel .my-fe-search .my-fe-search-top > input {
  border: 1px solid #ababab;
  padding: 0 20px 0 2px;
  width: 200px;
  height: 22px;
  line-height: 22px;
}
.my-filter-excel .my-fe-search .my-fe-search-top > .my-fe-search-icon {
  position: absolute;
  right: 5px;
  top: 10px;
}
.my-filter-excel .my-fe-search .my-fe-search-list {
  margin: 0;
  border: 1px solid #e2e4e7;
  padding: 2px 10px;
  overflow: auto;
  height: 140px;
}
.my-filter-excel .my-fe-search .my-fe-search-list .my-fe-search-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 3px 0;
  transition: 0.1s;
  position: relative;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
  }
}

.only-filter-btn {
  opacity: 0;
  font-size: 12px;
  position: absolute;
  right: 0;
  transition: all 0.2s ease;
  outline: none;
  border: none;
  background-color: #4584e6;
  border-radius: 5px;
  color: #f2f7ff;
  height: 20px;
}

.my-fe-search-item:hover {
  background-color: #f2f3f5;
}

.my-fe-search-item:hover .only-filter-btn {
  opacity: 0.8;
  cursor: pointer;
}

.my-filter-excel .my-fe-search .my-fe-search-list .my-fe-search-item .my-fe-search-item-icon {
  width: 16px;
}
.my-filter-excel .my-fe-footer {
  text-align: right;
  padding: 10px 10px 10px 0;
}
.my-fe-popup .my-fe-popup-filter {
  padding-left: 30px;
}
.my-fe-popup .my-fe-popup-filter > .my-fe-popup-filter-select {
  width: 120px;
}
.my-fe-popup .my-fe-popup-filter > .my-fe-popup-filter-input {
  margin-left: 15px;
  width: 380px;
}
.my-fe-popup .my-fe-popup-describe {
  padding: 20px 0 10px 0;
}
.my-fe-popup .my-fe-popup-concat {
  padding-left: 50px;
}
.my-fe-popup .my-fe-popup-footer {
  text-align: right;
}
.filter--li {
  padding: 0 10px 0 20px;
  height: 25px;
  line-height: 25px;
}
.filter--li:hover {
  background: #c5c5c5;
}
#iconContainer--funnel {
  position: absolute;
  left: 10px;
  top: 6px;
  font-size: 12px;
}
#iconContainer--right {
  position: absolute;
  right: 10px;
  top: 6px;
  font-size: 14px;
}
#iconContainer--checkbox {
  font-size: 16px;
  margin: 0 5px 0 5px;
}
.el-input {
  line-height: 35px;
  width: 100%;
}

.is-active {
  background-color: @primary-color;
  color: #fff;
}
.high-filter-span {
  margin-left: 10px;
  border: 1px solid @primary-color;
  border-radius: 5px;
  padding: 2px 5px;
  color: @primary-color;
}
</style>
